import PengaturanDimensiHeadNew from "../../../../../components/categories/siakad/laporan_adab/pengaturan_dimensi/HomeHead-New";
export default function Home() {
  
  return (
    <PengaturanDimensiHeadNew />
  );
}
